// extracted by mini-css-extract-plugin
export var labelWrapper = "_gn-0";